module.exports = __webpack_public_path__ + "img/service.43423a2e.jpg";